module.exports = __webpack_public_path__ + "img/楼栋.fda1ea69.png";